import React from "react";
import BinaryPickerFormField from "~/visuals/organisms/BinaryPickerFormField";
import { ChargeFieldState } from "./types";

export const ChargeBillableToggle: React.FC<ChargeFieldState> = (props) => {
  return (
    <BinaryPickerFormField
      {...{
        disabled: props.disabled,
        label: "Billable?",
        helperText: "",
        formField: "billable",
      }}
    />
  );
};

export const ChargeTaxableToggle: React.FC<ChargeFieldState> = (props) => {
  return (
    <BinaryPickerFormField
      {...{
        disabled: props.disabled,
        label: "Taxable?",
        helperText: "",
        formField: "taxable",
      }}
    />
  );
};

export const ChargeOverrideRateToggle: React.FC<ChargeFieldState> = (props) => {
  return (
    <BinaryPickerFormField
      {...{
        disabled: props.disabled,
        formField: "useCustomRate",
        label: "Override Rate",
        helperText: "",
      }}
    />
  );
};
